import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from '../../../utils'

export const createInsightsRoutesMap = (prefix: string) => ({
  overview: pathJoin(prefix)('overview').chainWithTitle({
    title: <T _str="Overview" />,
    breadCrumbTitle: <T _str="Overview" />,
  }),
  analyst: pathJoin(prefix)('analyst').chainWithTitle({
    title: <T _str="Analyst" />,
    breadCrumbTitle: <T _str="Analyst" />,
  }),
  compare: pathJoin(prefix)('compare').chainWithTitle({
    title: <T _str="Compare" />,
    breadCrumbTitle: <T _str="Compare" />,
  }),
  dashboards: pathJoin(prefix)('dashboards').chainWithTitle({
    title: <T _str="Dashboards" />,
    breadCrumbTitle: <T _str="Dashboards" />,
  }),
  dashboard: pathJoin(prefix)('dashboards/:id').chainWithTitle({
    title: <T _str="Dashboard" />,
    breadCrumbTitle: <T _str="Dashboard" />,
  }),
  catalog: pathJoin(prefix)('catalog').chainWithTitle({
    title: <T _str="Metric catalog" />,
    breadCrumbTitle: <T _str="Metric catalog" />,
  }),
  explore: pathJoin(prefix)('explore').chainWithTitle({
    title: <T _str="Explore" />,
    breadCrumbTitle: <T _str="Explore" />,
  }),
  alerts: pathJoin(prefix)('alerts').chainWithTitle({
    title: <T _str="Alerts" />,
    breadCrumbTitle: <T _str="Alerts" />,
  }),
  digest: pathJoin(prefix)('digest').chainWithTitle({
    title: <T _str="Digest" />,
    breadCrumbTitle: <T _str="Digest" />,
  }),
  reports: pathJoin(prefix)('reports').chainWithTitle({
    title: <T _str="Reports & packs" />,
    breadCrumbTitle: <T _str="Reports & packs" />,
  }),
  haulers: pathJoin(prefix)('haulers').chainWithTitle({
    title: <T _str="Contractors" />,
    breadCrumbTitle: <T _str="Contractors" />,
  }),
  drivers: pathJoin(prefix)('drivers').chainWithTitle({
    title: <T _str="Drivers" />,
    breadCrumbTitle: <T _str="Drivers" />,
  }),
  dispatch: pathJoin(prefix)('dispatch').chainWithTitle({
    title: <T _str="Dispatch" />,
    breadCrumbTitle: <T _str="Dispatch" />,
  }),
  compliance: pathJoin(prefix)('compliance').chainWithTitle({
    title: <T _str="Compliance" />,
    breadCrumbTitle: <T _str="Compliance" />,
  }),
  audit: pathJoin(prefix)('audit').chainWithTitle({
    title: <T _str="Audit trail" />,
    breadCrumbTitle: <T _str="Audit trail" />,
  }),
  published: pathJoin(prefix)('published').chainWithTitle({
    title: <T _str="Exposure" />,
    breadCrumbTitle: <T _str="Exposure" />,
  }),
})
